const $inject = ['$http', '$q', 'APP_CONFIG'];

const paymentMethodsService = function paymentMethodsService($http, $q, APP_CONFIG) {
  let service = {
    get,
    set,
    getTravellerSectorsGrouped,
    getAllTravellerSectorsGrouped,
    findGroupIdsFoundInEverySector,
    getAllTravellerAllSectorsGrouped,
    addPaymentMethod,
    populateEachPaxWithSelectedPaymentMethods,
    doGroupIdsMatchToInvoicePaymentMethod,
    checkAllPaxPaymentsSelected,
    purgeDuplicatePaymentMethods,
    checkForCVV,
    addCVVsToPayments,
    updatedPaxWithPayments: undefined,
    paymentMethods: [],
    activeGroupedSectors: [],
    activeAllSectors: [],
    activeSelectedAllPayment: undefined,
    overrideSectorPaymentChoice: {},
    selectedPaymentMethods: {},
    tabIndex: 2
  };

  function get(itineraryId) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itineraryPaymentMethod', itineraryId);

    $http.get(apiConfig.url, {apiVersion:apiConfig.version})
      .then((res) => {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function set(data) {
    service.paymentMethods = data;
  }

  function getTravellerSectorsGrouped(traveller) {
    return _.flowRight(createGroupDescriptions, createPaymentOptionsArray, createSectorGrpArray, createSectorArray)(traveller);
  }

  function getAllTravellerSectorsGrouped(travellers) {
    let sectors = [];

    _.forEach(travellers, traveller => {
      sectors.push(createSectorArray(traveller));
    });

    sectors = _.flatten(sectors);

    return _.flowRight(checkPaymentMethodsIncludeEveryGroupId, combineGroupIds, groupSectorTypes, createGroupDescriptions, createPaymentOptionsArray, createSectorGrpArray)(sectors);
  }


  function createSectorArray(traveller) {
    const sectors = [];

    if (traveller.Flights.length > 0) {
      sectors.push({
        sectorType: 'flights',
        sectors: traveller.Flights
      })
    }

    if (traveller.Hotels.length > 0) {
      sectors.push({
        sectorType: 'hotels',
        sectors: traveller.Hotels
      })
    }

    if (traveller.Cars.length > 0) {
      sectors.push({
        sectorType: 'cars',
        sectors: traveller.Cars
      })
    }

    if (traveller.Rails.length > 0) {
      sectors.push({
        sectorType: 'rails',
        sectors: traveller.Rails
      })
    }

    return sectors;
  }

  function createSectorGrpArray(sectors) {
    return _.map(sectors, sectorType => {

      sectorType.groups = [];

      _.forEach(sectorType.sectors, sector => {

        const group = _.find(sectorType.groups, (group) => {
          return group.groupId === sector.GroupIdentifier;
        });

        if (!group) {
          sectorType.groups.push(
            {
              groupId: sector.GroupIdentifier,
              sectors: [sector]
            }
          )
        } else {
          group.sectors.push(sector);
        }
      });

      return sectorType
    });
  }


  function createPaymentOptionsArray(groupedSectors) {
    const paymentMethods = service.paymentMethods;

    return _.map(groupedSectors, sectorType => {

      _.forEach(sectorType.groups, group => {
        group.paymentOptions = _.filter(paymentMethods, (paymentMethod) => {
          return paymentMethod.SectorGroups.indexOf(group.groupId) > -1;
        });
      });

      return sectorType
    });

  }

  function createGroupDescriptions(groupedSectors) {
    return _.map(groupedSectors, sectorGroup => {
      _.forEach(sectorGroup.groups, group => {
        const descriptions = [];

        if (sectorGroup.sectorType === 'flights') {
          _.forEach(group.sectors, sector => {
            descriptions.push(`${sector.Carrier} ${sector.FlightNumber}`);
          })
        }

        if (sectorGroup.sectorType === 'hotels') {
          _.forEach(group.sectors, sector => {
            descriptions.push(`${sector.HotelName}`);
          })
        }

        group.groupDescriptions = descriptions.join(', ');
      });

      return sectorGroup;
    });
  }

  function findGroupIdsFoundInEverySector(sectors) {

    let allGroupIdsInSectors = [];
    const paymentMethodsFoundInAllActiveGroupIds = [];

    _.forEach(sectors, sector => {
      _.forEach(sector.groups, group => {
        allGroupIdsInSectors.push(group.groupId)
      });
    });

    allGroupIdsInSectors = _.uniq(allGroupIdsInSectors);

    _.forEach(service.paymentMethods, paymentMethod => {
      let intersection = _.intersection(allGroupIdsInSectors, paymentMethod.SectorGroups);

      if (intersection.length === allGroupIdsInSectors.length) {
        paymentMethodsFoundInAllActiveGroupIds.push(paymentMethod);
      }
    });


    return paymentMethodsFoundInAllActiveGroupIds;
  }

  function addPaymentMethod(newPaymentMethod) {
    const allGroupIds = [];

    _.forEach(service.paymentMethods, paymentMethod => {
      if (paymentMethod.Payment.PaymentType != 'Invoice' && !paymentMethod.IsPaymentOptionLocked) {
        allGroupIds.push(paymentMethod.SectorGroups);
      }
    });

    const groupIds = _.flowRight(_.uniq, _.flatten)(allGroupIds);

    const newPaymentObj = {
      Payment: {
        ExpiryMonth: newPaymentMethod.cardExpiryMonth,
        ExpiryYear: newPaymentMethod.cardExpiryYear,
        Holder: newPaymentMethod.cardHolder,
        Number: newPaymentMethod.cardNumber,
        PaymentType: "Card",
        Reference: null,
        SecurityCode: null,
        SecurityCodeRequired: true,
        Type: {
          Code: newPaymentMethod.Card.Type.Code,
          Value: newPaymentMethod.Card.Type.Code
        }
      },
      SectorGroups: groupIds
    };

    service.paymentMethods.push(newPaymentObj);
    service.activeAllSectors.push(newPaymentObj);
    service.activeSelectedAllPayment = newPaymentObj;
  }

  function groupSectorTypes(sectorGroups) {
    const sectorsByGroup = {
      flights: [],
      rails: [],
      hotels: [],
      cars: []
    };

    _.forEach(sectorGroups, sectorGroup => {
      sectorsByGroup[sectorGroup.sectorType].push(sectorGroup)
    });

    return sectorsByGroup;
  }

  function combineGroupIds(sectorsByGroup) {
    const groupIDsBySectorType = {};

    _.forEach(sectorsByGroup, (sectors, sectorType) => {
      if (sectors.length > 0) {
        groupIDsBySectorType[sectorType] = [];
        _.forEach(sectors, sector => {
          _.forEach(sector.groups, group => {
            groupIDsBySectorType[sectorType].push(group.groupId);
          });
        })
      }
    });

    return groupIDsBySectorType;
  }

  function checkPaymentMethodsIncludeEveryGroupId(groupIDsBySectorType) { // forgive me
    const paymentsAvailableToEachSectorType = {};

    _.forEach(groupIDsBySectorType, (sectorGroupIds, sectorType) => {
      paymentsAvailableToEachSectorType[sectorType] = [];

      _.forEach(service.paymentMethods, paymentMethod => {
        const existsInAll = sectorGroupIds.every(function (v, i) {
          return paymentMethod.SectorGroups.indexOf(v) !== -1;
        });

        if (existsInAll) {
          paymentsAvailableToEachSectorType[sectorType].push(paymentMethod);
        }
      });
    });

    return paymentsAvailableToEachSectorType;
  }

  function getAllTravellerAllSectorsGrouped(groupedSectorPayments) {
    return _.flowRight(findPaymentMethodByGroupIds, findGroupIdsFoundInEverySectorGroup)(groupedSectorPayments);
  }

  function findGroupIdsFoundInEverySectorGroup(groupedSectorPayments) {
    const groupIds = [];

    _.forIn(groupedSectorPayments, (sectorPaymentGroup) => {
      _.forEach(sectorPaymentGroup, (sectorPayment) => {
        groupIds.push(sectorPayment.SectorGroups);
      });
    });

    return _.uniq(_.flatten(groupIds));
  }

  function findPaymentMethodByGroupIds(groupIds) {
    const matchedPayments = [];
    if(groupIds.length > 0){
      _.forEach(service.paymentMethods, paymentMethod => {
        if (_.difference(groupIds, paymentMethod.SectorGroups).length === 0) {
          matchedPayments.push(paymentMethod);
        }
      });
    }
    return matchedPayments;
  }

  function populateEachPaxWithSelectedPaymentMethods(paymentMethods, travellers, cachedTravelers) {
    return matchPaymentsToTravellers(paymentMethods, travellers, cachedTravelers);
  }

  function matchPaymentsToTravellers(paymentMethods, travellers, cachedTravelers) {
    let paymentMissing = 0;

    _.forEach(travellers, (pax, paxIndex) => {
      const paymentsCopy = angular.copy(pax.Configurations.PaymentMethod.PaymentItems);
      pax.Configurations.PaymentMethod.PaymentItems = [];

      _.forEach(pax.Flights, (flight) => {
        if (paymentMethods.allPax && paymentMethods.allPax.flights) {
          let matchedCache = cachedTravelers[paxIndex].Configurations.PaymentMethod.PaymentItems.find(item => {
            return item.SectorGroupIdentifier === flight.GroupIdentifier;
          });

          let locked = false;
          if (matchedCache && matchedCache.Card) {
            let paymentMatch = service.paymentMethods.find(paymentMethod => paymentMethod.Payment.Reference === matchedCache.Card.Reference);
            if (paymentMatch && paymentMatch.IsPaymentOptionLocked) locked = true;
          }

          if (locked) {
            pax.Configurations.PaymentMethod.PaymentItems.push(matchedCache);
          } else {
            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.flights.Payment, flight.GroupIdentifier, 'Flight'));
          }
        }

        else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier]) {

          if (!paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment) {
            const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Flight', flight.GroupIdentifier);

            if (foundPayment.Card) {
              paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Card;
            } else {
              paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Invoice;
            }
          }

          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment, flight.GroupIdentifier, 'Flight'));
        }

        else {
          paymentMissing += 1;
        }
      });

      _.forEach(pax.Rails, (rail) => {

        if (paymentMethods.allPax && paymentMethods.allPax.rails) {
          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.rails.Payment, rail.GroupIdentifier, 'Rail'));
        }

        else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier]) {

          if (!paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment) {
            const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Rail', rail.GroupIdentifier);

            if (foundPayment.Card) {
              paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Card;
            } else {
              paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Invoice;
            }
          }


          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment, rail.GroupIdentifier, 'Rail'));
        }

        else {
          paymentMissing += 1;
        }
      });


      _.forEach(pax.Hotels, (hotel) => {

        if (paymentMethods.allPax && paymentMethods.allPax.hotels) {
          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.hotels.Payment, hotel.GroupIdentifier, 'Hotel'));
        }

        else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier]) {

          if (!paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment) {
            const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Hotel', hotel.GroupIdentifier);

            if (foundPayment.Card) {
              paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Card;
            } else {
              paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Invoice;
            }
          }

          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment, hotel.GroupIdentifier, 'Hotel'));
        }

        else {
          paymentMissing += 1;
        }
      });

      _.forEach(pax.Cars, (car) => {

        if (paymentMethods.allPax && paymentMethods.allPax.cars) {
          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.cars.Payment, car.GroupIdentifier, 'Car'));
        }

        else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].cars[car.GroupIdentifier]) {

          if (!paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment) {
            const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Car', car.GroupIdentifier);

            if (foundPayment.Card) {
              paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Card;
            } else {
              paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Invoice;
            }
          }

          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment, car.GroupIdentifier, 'Car'));
        }

        else {
          paymentMissing += 1;
        }
      });
    });

    return {
      travellers: travellers,
      missingPayments: paymentMissing > 0
    };
  }

  function doGroupIdsMatchToInvoicePaymentMethod(grpIds, paymentMethods) {
    let typeInvoice = false;

    _.each(grpIds, grpId => {
      if (!typeInvoice) {
        _.each(paymentMethods, payment => {
          if (payment.SectorGroups.indexOf(grpId) > -1 && !typeInvoice &&
            payment.Payment.PaymentType === 'Invoice') {
            typeInvoice = true;
          }
        });
      }
    });

    return typeInvoice;
  }

  function buildPaymentObj(Payment, grpId, type) {
    let paymentObj = {};

    if (Payment.PaymentType === 'Invoice') {
      paymentObj = {
        Card: null,
        Invoice: {
          PaymentType: 'Invoice',
          Reference: 'Invoice'
        },
        SectorGroupIdentifier: grpId,
        Type: type
      };
    } else {
      paymentObj = {
        Card: Payment,
        Invoice: null,
        SectorGroupIdentifier: grpId,
        Type: type
      };
    }

    return paymentObj;
  }

  function checkAllPaxPaymentsSelected(pax) {
    if (!pax) {
      return
    }
    let eachSectorHasPayment = true;
    let sectorGrpIds = [];

    _.forEach(pax.Flights, flight => {
      sectorGrpIds.push(flight.GroupIdentifier);
    });

    _.forEach(pax.Rails, rail => {
      sectorGrpIds.push(rail.GroupIdentifier);
    });

    _.forEach(pax.Hotels, hotel => {
      sectorGrpIds.push(hotel.GroupIdentifier);
    });

    _.forEach(pax.Cars, car => {
      sectorGrpIds.push(car.GroupIdentifier);
    });

    sectorGrpIds = _.uniq(sectorGrpIds);

    sectorGrpIds.every(grpId => {
      if (eachSectorHasPayment) {
        const findMatch = _.find(pax.Configurations.PaymentMethod.PaymentItems, PaymentItem => {
          return PaymentItem.SectorGroupIdentifier === grpId;
        });

        eachSectorHasPayment = !!findMatch;
      }

      return eachSectorHasPayment;
    });

    return eachSectorHasPayment
  }

  function findPaymentWithTypeAndGrpId(payments, type, grpId) {
    return _.find(payments, payment => {
      return payment.SectorGroupIdentifier === grpId && payment.Type === type;
    });
  }

  function purgeDuplicatePaymentMethods(payments) {
    const grpIds = [];

    return _.filter(payments, payment => {
      if (grpIds.indexOf(payment.SectorGroupIdentifier) === -1) {
        grpIds.push(payment.SectorGroupIdentifier);
        return true
      } else {
        return false;
      }
    });
  }

  function checkForCVV(PaymentItems, cvvObj) {
    let allCVVsPresent = true;

    PaymentItems.every(payment => {
      if (allCVVsPresent && payment.Card && payment.Card.SecurityCodeRequired) {
        allCVVsPresent = cvvObj[payment.Card.Reference];
      }

      return allCVVsPresent;
    });

    return allCVVsPresent;
  }

  function addCVVsToPayments(paymentItems, cvvObj) {
    return _.forEach(paymentItems, payment => {
      if (payment.Card && payment.Card.SecurityCodeRequired) {
        payment.Card.SecurityCode = cvvObj[payment.Card.Reference];
      }
    });

  }

  return service;
};


paymentMethodsService.$inject = $inject;

export default paymentMethodsService;



// WEBPACK FOOTER //
// ./src/services/paymentMethodsService.js